import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Promise from 'babel-runtime/core-js/promise';

// import _ from 'lodash'
import EditCreative from './edit-creative.vue';
import { changeVersionName } from '@/api/dmaker/custom';
import { getDmakerCustomInfo } from '@/api/creative/custom.js';
import _ from 'lodash';

export default {
  name: 'editVersion.vue',

  components: {
    EditCreative: EditCreative
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    readMode: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      dialog: {
        title: this.$t('playTurbo.commonTemplate.versionEditTitle')
      },
      schema: {
        name: {
          label: this.$t('playTurbo.commonTemplate.creativeInfo.form.versionName.label'),
          prop: 'name',
          field: {
            placeholder: this.$t('playTurbo.commonTemplate.creativeInfo.form.versionName.placeholder'),
            clearable: true
          },
          rules: [{
            required: true,
            trigger: 'blur',
            message: this.$t('playTurbo.commonTemplate.creativeInfo.form.versionName.empty')
          }, {
            validator: this.versionNameValidator,
            trigger: 'blur'
          }]
        },
        promotedType: {
          visible: false
        },
        platform: {
          visible: false
        },
        iOSAppUrl: {
          field: {
            disabled: true
          }
        },
        iOSAppIcon: {
          field: {
            disabled: true,
            disabledUpload: true
          }
        },
        iOSAppName: {
          field: {
            disabled: true
          }
        },
        androidAppUrl: {
          field: {
            disabled: true
          }
        },
        androidAppIcon: {
          field: {
            disabled: true,
            disabledUpload: true
          }
        },
        androidAppName: {
          field: {
            disabled: true
          }
        }
      }
    };
  },


  computed: {},

  watch: {},

  mounted: function mounted() {},


  methods: {
    versionNameValidator: function versionNameValidator(rule, value, callback) {
      var re = /^[0-9a-zA-Z_]{1,50}$/;
      if (re.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('playTurbo.commonTemplate.creativeInfo.form.versionName.validateMessage')));
      }
    },
    handleUpdateSuccess: function handleUpdateSuccess(data) {
      this.$emit('update-success', data);
    },
    handleFetchProject: function handleFetchProject(data) {
      return new _Promise(function (resolve, reject) {
        getDmakerCustomInfo({ custom_id: data.project_id }).then(function (res) {
          if (_.get(res, 'data.data')) {
            // 版本弹窗需要展示app 信息，添加promotedType
            res.data.data.promoted_type = 'app';
          }
          resolve(res);
        });
      });
    },
    handleUpdateVersionName: function handleUpdateVersionName(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log('传入参数', params);
                _context.next = 4;
                return changeVersionName({
                  id: params.project_id,
                  name: params.name
                });

              case 4:
                res = _context.sent;
                return _context.abrupt('return', res);

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  }
};